import { CollaborationState } from '@/signalr';

export type InvolvedAgencyStateComponentProps = {
  collaborationState: CollaborationState;
  agencyName: string;
};

function effectiveCssClass(collaborationState: CollaborationState): string | null {
  switch (collaborationState) {
    case CollaborationState.Invited:
      return 'bg-warning-subtle px-1 rounded-2';
    case CollaborationState.Accepted:
      return 'bg-success-subtle px-1 rounded-2';
    case CollaborationState.Declined:
      return 'bg-danger-subtle px-1 rounded-2';
    default:
      return null;
  }
}

function effectiveCollaborationStateIcon(collaborationState: CollaborationState): string | null {
  switch (collaborationState) {
    case CollaborationState.Invited:
      return 'fal fa-question-circle';
    case CollaborationState.Accepted:
      return 'fal fa-check-circle';
    case CollaborationState.Declined:
      return 'fal fa-times-circle';
    default:
      return null;
  }
}

export function InvolvedAgencyStateComponent({ collaborationState, agencyName }: InvolvedAgencyStateComponentProps) {
  const icon = effectiveCollaborationStateIcon(collaborationState);

  return (
    <div className={effectiveCssClass(collaborationState) ?? ''}>
      <span>{agencyName}</span>

      {icon !== null && <i className={`${icon} fa-sm ms-1`}></i>}
    </div>
  );
}
